import { Trophy, Package, BarChart3, Calendar } from 'lucide-react'
import clsx from 'clsx'

/**
 * Tab definitions for Salon Analysis
 */
export const SALON_ANALYSIS_TABS = [
  { id: 'top20', label: 'TOP 20 Salonów', icon: Trophy },
  { id: 'stock', label: 'Zatowarowanie i Ekspozycja', icon: Package },
  { id: 'pareto', label: 'Analiza Pareto', icon: BarChart3 },
  { id: 'heatmap', label: 'Heatmapa miesięczna', icon: Calendar }
]

/**
 * Tab Button component
 */
const TabButton = ({ tab, isActive, onClick, disabled }) => {
  const Icon = tab.icon
  
  const baseClasses = 'flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-all focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1'
  const activeClasses = 'bg-blue-500 text-white shadow-sm'
  const inactiveClasses = 'text-gray-600 hover:bg-gray-200 hover:text-gray-800'
  const disabledClasses = 'opacity-50 cursor-not-allowed'
  
  return (
    <button
      onClick={() => onClick(tab.id)}
      disabled={disabled}
      className={clsx(
        baseClasses,
        isActive ? activeClasses : inactiveClasses,
        disabled && disabledClasses
      )}
    >
      <Icon className="h-4 w-4 mr-2" />
      <span className="hidden sm:inline">{tab.label}</span>
      <span className="sm:hidden">{tab.label.split(' ')[0]}</span>
    </button>
  )
}

/**
 * Tabs Navigation component for Salon Analysis sub-reports
 */
const SalonAnalysisTabs = ({
  activeTab,
  onChange,
  analysisMode,
  hasStockExposition = true
}) => {
  // Filter tabs based on conditions
  const visibleTabs = SALON_ANALYSIS_TABS.filter(tab => {
    // Hide heatmap for non-yearly analysis
    if (tab.id === 'heatmap' && analysisMode !== 'yearly') {
      return false
    }
    // Hide stock exposition if not available
    if (tab.id === 'stock' && !hasStockExposition) {
      return false
    }
    return true
  })

  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2 p-1.5 bg-gray-100 rounded-xl">
        {visibleTabs.map((tab) => (
          <TabButton
            key={tab.id}
            tab={tab}
            isActive={activeTab === tab.id}
            onClick={onChange}
          />
        ))}
      </div>
    </div>
  )
}

export default SalonAnalysisTabs
